export const STATISTICS_NODE = 'statistics';
